import { html } from 'lit';
import componentStyles from './header.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import { classMap } from 'lit/directives/class-map.js';

export default class Header extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * Main content area title
       */
      isMLP: { type: Boolean },
      isHPSite: { type: Boolean },
    };
  }

  constructor() {
    super();
    this.isMLP = false;
    this.isHPSite = false;
  }

  render() {
    return html`
      <header
        class="${classMap({
          'header-wrapper': true,
          'header-wrapper--mlp': this.isMLP,
          'header-wrapper--hp': this.isHPSite,
        })}"
      >
        <hf-container class="header-wrapper__inner">
          <slot></slot>
        </hf-container>
      </header>
    `;
  }
}

customElements.define('hf-header', Header);
